<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 26" fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M2 4C0.89543 4 0 4.89544 0 6V24C0 25.1046 0.89543 26 2 26H28C29.1046 26 30 25.1046 30 24V6C30 4.89544 29.1046 4 28 4H2ZM2 6H28V7.84988C27.8348 7.84972 27.6676 7.89502 27.5178 7.9901L15 15.9341L2.48224 7.9901C2.33242 7.89502 2.1652 7.84972 2 7.84988V6ZM2 9.81594V24H28V9.81594L15.4822 17.7599C15.1879 17.9467 14.8121 17.9467 14.5178 17.7599L2 9.81594Z"
       />
  </svg>
</template>
<style scoped>
svg {
  transition: all 0.3s ease-in-out;
}
</style>
